import router from "@/router";
import { RawLocation } from "vue-router";
import {
  SystemView,
  ProfileRouteParams,
  UserRouteParams,
  ListRouteParams,
  SaveSpaceRouteParams,
  SaveCampusRouteParams,
  SaveDependenciesRouteParams,
  DoctorProfileRouteParams,
  RegisterRouteParams,
  IntelliticksRouteParams
} from "@/shared/constants/Views.enum";

export class NavigationService {
  /**
   * Navega a una vista nombrada del sistema con parámetros y query opcionales.
   */
  public static navigateTo(
    routeName: SystemView.PROFILE,
    params: ProfileRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.USER,
    params: UserRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.LIST,
    params: ListRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.SAVE_SPACE,
    params?: SaveSpaceRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.SAVE_CAMPUS,
    params?: SaveCampusRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.SAVE_DEPENDENCIES,
    params?: SaveDependenciesRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.DOCTOR_PROFILE,
    params?: DoctorProfileRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.REGISTER,
    params?: RegisterRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView.VIEW_INTELLETICKS,
    params?: IntelliticksRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView | string,
    params?: Record<string, any>,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static navigateTo(
    routeName: SystemView | string,
    params?: Record<string, any>,
    query?: Record<string, any>
  ): Promise<any> | void {
    return router.push({ name: routeName, params, query }).catch(err => {
      console.error("Navigation error:", err);
      throw err;
    });
  }

  /**
   * Reemplaza la ruta actual con una vista nombrada del sistema.
   */
  public static replaceTo(
    routeName: SystemView.PROFILE,
    params: ProfileRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.USER,
    params: UserRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.LIST,
    params: ListRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.SAVE_SPACE,
    params?: SaveSpaceRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.SAVE_CAMPUS,
    params?: SaveCampusRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.SAVE_DEPENDENCIES,
    params?: SaveDependenciesRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.DOCTOR_PROFILE,
    params?: DoctorProfileRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.REGISTER,
    params?: RegisterRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView.VIEW_INTELLETICKS,
    params?: IntelliticksRouteParams,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView | string,
    params?: Record<string, any>,
    query?: Record<string, any>
  ): Promise<any> | void;
  public static replaceTo(
    routeName: SystemView | string,
    params?: Record<string, any>,
    query?: Record<string, any>
  ): Promise<any> | void {
    return router.replace({ name: routeName, params, query }).catch(err => {
      if (err.name !== "NavigationDuplicated") {
        console.error("Navigation replace error:", err);
      }
    });
  }

  /**
   * Navega a una ruta basada en path literal o RawLocation de vue-router.
   */
  public static navigateByPath(path: RawLocation): Promise<any> | void {
    return router.push(path).catch(err => {
      if (err.name !== "NavigationDuplicated") {
        console.error("Navigation by path error:", err);
      }
    });
  }

  /**
   * Retrocede en el historial del navegador.
   */
  public static goBack(): void {
    router.go(-1);
  }

  /**
   * Avanza en el historial del navegador.
   */
  public static goForward(): void {
    router.go(1);
  }

  /**
   * Obtiene la ruta actual.
   */
  public static getCurrentRoute() {
    return router.currentRoute;
  }
}
